import React, { useState } from 'react';
import { Pencil, Check, X, RotateCcw } from 'lucide-react';

const fmt = (v, force = false) => (v > 0 || force ? `${Number(v || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €` : '-');

// Cellule CMDPS : valeur calculée + crayon pour saisie manuelle, badge « manuel » et retour au calcul.
export const CmdpsOverrideCell = ({ value, calcule, manuel, onSave, testid, valueClassName = '' }) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');

  const start = () => { setDraft(Number(value || 0).toFixed(2)); setEditing(true); };
  const commit = () => {
    const n = parseFloat(String(draft).replace(',', '.'));
    if (!isNaN(n) && n >= 0) onSave(n);
    setEditing(false);
  };

  if (editing) {
    return (
      <div className="inline-flex items-center gap-1 justify-end">
        <input type="text" inputMode="decimal" autoFocus value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') commit(); if (e.key === 'Escape') setEditing(false); }}
          className="w-28 px-2 py-1 border border-[#397DFF] rounded text-right text-sm font-mono"
          data-testid={`${testid}-input`} />
        <button type="button" onClick={commit} className="p-1 text-[#10D183] hover:bg-[#ECFDF5] rounded" title="Valider" data-testid={`${testid}-save`}>
          <Check className="w-4 h-4" />
        </button>
        <button type="button" onClick={() => setEditing(false)} className="p-1 text-[#687175] hover:bg-[#F5F6F9] rounded" title="Annuler" data-testid={`${testid}-cancel`}>
          <X className="w-4 h-4" />
        </button>
      </div>
    );
  }

  return (
    <div className="inline-flex items-center gap-1.5 justify-end">
      {manuel && (
        <span className="text-[10px] font-semibold uppercase tracking-wide text-[#B45309] bg-[#FEF3C7] px-1.5 py-0.5 rounded"
          title={`Valeur calculée : ${fmt(calcule)}`} data-testid={`${testid}-badge`}>
          manuel
        </span>
      )}
      <span className={valueClassName} data-testid={`${testid}-value`}>{fmt(value, manuel)}</span>
      <button type="button" onClick={start} className="p-1 text-[#397DFF] hover:bg-[#F0F7FF] rounded" title="Saisir la valeur manuellement" data-testid={`${testid}-edit`}>
        <Pencil className="w-3.5 h-3.5" />
      </button>
      {manuel && (
        <button type="button" onClick={() => onSave(null)} className="p-1 text-[#687175] hover:bg-[#F5F6F9] rounded"
          title={`Revenir au calcul (${fmt(calcule)})`} data-testid={`${testid}-reset`}>
          <RotateCcw className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
};
